<template>
    <div>
        <div v-if='message' v-text='message' class='text-center p-2' style='position: absolute; z-index: 10001; background-color: white; left: 0; right: 0; width:100%'></div>
        <div :class='"spinnerContainer" + (fixed ? " spinnerContainerFixed" : "")' v-on:click='preventEvents' ref="spinnerContainer">
            
            <div class="spinner" ref="spinner"></div>
        </div>
    </div>
</template>

<script>
	export default {
		props: {
			fixed: {
				default: false
			}
		},
		data: function(){
			return {
                message: null
			};
		},
		mounted() {
			//this.$refs.spinnerContainer.
		},
		computed: {
		},
		methods: {
			preventEvents(e) {
				e.stopPropagation();
				return false;
			}
		}
    }
</script>
